export default __webpack_public_path__ + "static/media/G-3.9dadf7d8.svg";